<template>
  <div :class="(boxStyle != false) ? 'box box-primary' : ''">
    <div class="box-body">
      <!-- Search Filter -->
      <div
        v-if="useFilterSelect"
        style="display:-webkit-box;margin:5px 20px;float:right;border:0px solid red;text-align:right;display: flex; justify-content: flex-end;margin-right: 0px"
      >
        <div style="margin-right: 2px;">
          <span
            style="justify-content: center;font-size:20px; padding: 10px;border: 1px solid #e5e5e5;border-radius: 5px;"
            class="fa fa-search"
          ></span>
        </div>
        <multiselect
          v-model="paymentStatusSelected"
          :placeholder="$t('common.status')"
          label="text"
          track-by="id"
          :multiple="true"
          :options="paymentStatusOptions"
          :showLabels="false"
          :maxHeight="200"
          style="width:250px;"
        ></multiselect>
      </div>
      <div
        v-show="useFilter"
        class="input-group input-group-sm"
        :class="[search_filter,isVisibility]"
      >
        <input
          type="text"
          name="query"
          @input="filterDataOnTable"
          v-model="searchQuery"
          class="form-control pull-right"
          :placeholder="$t('common.search')"
        />

        <div class="input-group-btn">
          <button type="submit" class="btn btn-default">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
      <!-- Table -->
      <div style="overflow: auto;width:100%;">
        <table
          class="table table-bordered"
          style="
        width: 100%;border:0px solid red;"
        >
          <tbody>
            <!-- Header and Border Default -->
            <ul
              v-if="hdBackground == undefined"
              style="display:contents;margin: 0;padding: 0; border:0px solid red;"
            >
              <!-- Add Header CheckBox -->
              <th v-if="useCheckBox" :style="headerDefaultBackground" style="text-align:center;">
                <!-- <b-form-checkbox></b-form-checkbox> -->
                <input type="checkbox" v-model="selectAll" @change="select" />
              </th>
              <!-- Add Header CheckBox -->
              <!-- v-for="key in columns" -->
              <!-- @click="sortBy(key)"-->
              <th
                :style="headerDefaultBackground"
                v-for="key in columns"
                :class="{ active: sortKey == key }"
                :key="key.id"
              >
                {{ $t(key) | capitalize }}
                <!--
                <span
                  v-if="arrow != undefined"
                  :class="[sortOrders[key] > 0 ? 'asc' :'dsc', arrow]"
                ></span>
                <span v-else class="arrow" :class="[sortOrders[key] > 0 ? 'asc' :'dsc']"></span>
                -->
              </th>
            </ul>
            <!-- Header and Border Defined -->
            <ul
              v-if="hdBackground != undefined"
              style="display:contents;margin: 0;padding: 0; border:1px solid red;"
            >
              <!-- Add Header CheckBox -->
              <th v-if="useCheckBox" :style="hdBackground" style="width:55px;text-align:center;">
                <!-- <b-form-checkbox></b-form-checkbox> -->
                <input type="checkbox" v-model="selectAll" @change="select" />
              </th>
              <!-- Add Header CheckBox -->
              <!-- @click="sortBy(columns[0]['text'] ? key.text : key)"-->
              <th
                v-for="key in columns"
                v-show="(columns[0]['text']) ? key.isHidden : true"
                :class="{ active: sortKey == (columns[0]['text'] ? key.text : key ) }"
                :key="key.id"
                style="text-align:center;"
                :style="{backgroundColor: '#4b646f',color:'white',border:'1px solid white',
                width:((columns[0]['text'] ? key.text : key ) == 'common.nonumber' ? '60px' :
                RegExp('phone|gender|country|code|status|fee|size').test(((columns[0]['text'] ? key.text : key ))) == true ? '120px' :
                RegExp('date').test(((columns[0]['text'] ? key.text : key ))) == true ? '130px' :
                RegExp('descriptionText').test(((columns[0]['text'] ? key.text : key ))) == true ? '800px' : '')}"
              >
                {{ (columns[0]['text']) ? $t(key.text) : $t(key) | capitalize }}
                <!--
                <span
                  v-if="arrow != undefined"
                  :class="[sortOrders[(columns[0]['text']) ? key.text : key] > 0 ? 'asc' :'dsc', arrow]"
                ></span>
                <span
                  v-else
                  class="arrow"
                  :class="[sortOrders[(columns[0]['text']) ? key.text : key] > 0 ? 'asc' :'dsc']"
                ></span>
                -->
              </th>
            </ul>

            <th
              v-if="views != undefined && hdBackground == undefined"
              :style="headerDefaultBackground"
              style="text-align:center;"
            >{{$t('common.preview')}}</th>
            <th
              v-if="views != undefined && hdBackground != undefined"
              :style="hdBackground"
              style="text-align:center;"
            >{{$t('common.preview')}}</th>
            <th
              v-if="actions != undefined && hdBackground == undefined"
              :style="headerDefaultBackground"
              style="text-align:center;"
            >{{$t('common.action')}}</th>
            <th
              v-if="actions != undefined && hdBackground != undefined"
              :style="hdBackground"
              style="text-align:left;width:100px;"
            >{{$t('common.action')}}</th>
            <!-- Aadd Data -->
            <ul
              v-if="tblBorder == undefined"
              style="display: contents;margin:0;padding: 0; border:1px solid red;"
            >
              <!-- :class="{ active: sortKey == key }" -->
              <tr
                :style="tableBorder"
                v-for="entry in filteredData"
                :key="entry.id"
                :uId="entry.id"
                :class="{active_line: (getStatusField == true) ? (status_field['apartment.apartment_status'] == entry['apartment.apartment_status']  ? true : false ) : false, row_mouse_pointer: row_mouse_pointer }"
              >
                <!-- <td v-for="key in columns" :style="tableBorder" :key="key.id">{{entry[key]}}</td> -->
                <!-- Add Column CheckBox -->
                <td v-if="useCheckBox" style="width:2%;text-align:center;">
                  <!-- <b-form-checkbox v-model="checkIdItems" :value="entry.id" id="entry.id" @change="checkItems(entry.id)"></b-form-checkbox> -->
                  <!-- <input
                    v-if="entry['apartment.status'] == 'Bàn Giao' || entry['apartment.status'] == 'Handover'"
                    disabled
                    type="checkbox"
                    :value="isGetInformationInvoice != undefined && isGetInformationInvoice ? entry : entry.id"
                    id="entry.id"
                    v-model="selected"
                    @change="checkItems($event)"
                  /> -->
                  <input                    
                    type="checkbox"
                    :value="isGetInformationInvoice != undefined && isGetInformationInvoice ? entry : entry.id"
                    id="entry.id"
                    v-model="selected"
                    @change="checkItems($event)"
                  />
                </td>
                <!-- Add Column CheckBox -->
                <!-- v-for="header_key in columns" -->
                <!--:style="tableBorder"-->
                <td
                  v-for="header_key in columns"
                  v-show="(columns[0]['text']) ? header_key.isHidden : true"
                  :key="(columns[0]['text']) ? header_key.text.id : header_key.id"
                  @click="onClickItemRow(entry.id)"
                  :style="{border: '1px solid #f4f4f4',
                  textAlign:((columns[0]['text'] ? header_key.text : header_key ) == 'common.nonumber'
                            || (columns[0]['text'] ? header_key.text : header_key ) == 'user.is_active' ? 'center' :
                  isNumber(entry[ (columns[0]['text']) ? header_key.text : header_key ]) ||
                  isDateString(entry[ (columns[0]['text']) ? header_key.text : header_key ]) ? 'right' :  'left'),
                  padding:((columns[0]['text'] ? header_key.text : header_key ) == 'user.is_active' ? '5px 7px 0px 30px' : '')}"
                >
                  <span v-if="useCheckBox">
                    <b-form-checkbox v-if="header_key == 'id'"></b-form-checkbox>
                  </span>

                  <span v-if="getCustomColumns">
                    <!-- {{(columns[0]['text']) ? header_key.text : header_key}} -->
                    <span
                      v-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'invoice.status_name'"
                      :class="[
                      {'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]},
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                    <!-- BEGIN - user.is_active -->
                    <span
                      v-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'user.is_active'"
                      :class="[
                        {'btn-label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]},
                                  customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`][entry[ (columns[0]['text']) ? header_key.text : header_key ]]]"
                    >
                    </span>
                    
                    <!-- END - user.is_active -->

                    <!-- Apartment Code -->
                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'invoice.apartment_code'"
                      :class="[
                      {'label': customColumns['invoice.status_name'][entry[ 'invoice.status_name']]},
                                customColumns['invoice.status_name'][entry[ 'invoice.status_name' ]]]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                    <!-- Total Fees -->
                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      (columns[0]['text'] ? header_key.text : header_key) == 'invoice.total_fees'"
                      :class="[
                      {'label': customColumns['invoice.status_name'][entry['invoice.status_name']]},
                                customColumns['invoice.status_name'][entry['invoice.status_name']]]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && entry[ (columns[0]['text']) ? header_key.text : header_key ] == $t('apartment.open')"
                      :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.open']}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.open']]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && entry[ (columns[0]['text']) ? header_key.text : header_key ] == $t('apartment.issue')"
                      :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.issue']}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.issue']]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) && entry[ (columns[0]['text']) ? header_key.text : header_key ] == $t('apartment.paid')"
                      :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.paid']}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['apartment.paid']]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>

                    <!--span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      ( (columns[0]['text'] ? header_key.text : header_key == 'invoice.date_issued') || (columns[0]['text'] ? header_key.text : header_key == 'invoice.date_paid') || (columns[0]['text'] ? header_key.text : header_key == 'invoice.due_date'))"
                      :class="[
                      {'label': (checkIsMonthCurrent(entry[ (columns[0]['text']) ? header_key.text : header_key ])) ?
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_curent'] :
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_last']},

                                ( (entry[ (columns[0]['text']) ? header_key.text : header_key ] != '') ? ( checkIsMonthCurrent(entry[ (columns[0]['text']) ? header_key.text : header_key ]) ?
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_curent'] :
                                customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]['date_last']) : '')]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span-->

                    <!-- date issued, date paid, due date -->
                    
                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key) &&
                      ( (columns[0]['text'] ? header_key.text : header_key) == 'invoice.date_issued' || (columns[0]['text'] ? header_key.text : header_key) == 'invoice.date_paid' || (columns[0]['text'] ? header_key.text : header_key) == 'invoice.due_date')"
                      :class="[
                      {'label': customColumns['invoice.status_name'][entry['invoice.status_name']]},
                                customColumns['invoice.status_name'][entry['invoice.status_name']]]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                    
                    <span
                      v-else-if="Object.keys(customColumns).includes((columns[0]['text']) ? header_key.text : header_key)"
                      :class="[{'label': customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]}, customColumns[`${(columns[0]['text']) ? header_key.text : header_key}`]]"
                    >{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                   
                    <span v-else>{{ entry[ (columns[0]['text']) ? header_key.text : header_key ]}}</span>
                  </span>
                  
                  <!-- add containLink -->
                  <span v-else-if="containLink">
                    <span v-if="header_key.text== 'documentation.url'">
                      <a
                        :href = entry[header_key.text]
                        target="_blank"
                        style="color: #00c0ef"
                        :style="entry[header_key.text]?'color: #00c0ef' : 'color: #dd4b39'"
                      >{{entry['documentation.name']}}
                      </a>
                    </span>
                    <span v-else>{{(columns[0]['text']) ? entry[header_key.text] : entry[header_key]}}</span>
                  </span>
                  <span v-else>{{(columns[0]['text']) ? entry[header_key.text] : entry[header_key]}}</span>
                   
                </td>

                <!-- Add Views -->
                <td v-if="views !=undefined">
                  <lte-hyperlink v-for="item in views" :key="item" left_icon="fa fa-eye">{{item}}</lte-hyperlink>
                </td>

                <!-- Add Actions Edit/Delete -->
                <td
                  id="actionColunm"
                  v-if="actions !=undefined"
                  style="width:100%;height:auto;border:0px solid green;display:inline-block"
                >
                  <div style="border:0px solid red;height:100%;text-align:center;">
                    <div
                      class="btn-group"
                      style="border:0px solid blue;width:auto;display:inline-flex;"
                    >
                      <button
                        id="more-btn"
                        type="button"
                        class="btn more-btn dropdown-toggle"
                        :class="colorAction !==undefined ? colorAction : 'btn-danger'"
                        data-toggle="dropdown"
                      >
                        <span class="more-dot"></span>
                        <span class="more-dot"></span>
                        <span class="more-dot"></span>
                      </button>
                      <ul
                        class="dropdown-menu"
                        role="menu"
                        style="min-width:90px;margin-top:0px;text-align:center;"
                      >
                        <li v-for="item in actions" :key="item">
                          <lte-button
                            :key="item"
                            :type="(item === 'common.modify') ? 'btn btn-primary' : ((item === 'common.delete') ? 'btn btn-danger' : ((item === 'common.sendPdf') ? 'btn btn-warning' : 'btn info'))"
                            :right_icon="(item ==='common.modify') ? 'glyphicon glyphicon-edit' : (item ==='common.delete') ? 'glyphicon glyphicon-trash' : ((item==='common.booking') ? 'fa fa-list-alt' : ((item == 'common.sendPdf') ? 'fa fa-file-pdf-o' : 'fa fa-print'))"
                            :target="(item ==='common.modify') ? '' : ((item ==='common.delete') ? '' : ((item == 'common.sendPdf') ? '' : '_blank'))"
                            style="margin-left:6px;"
                            @click="(item==='common.modify') ? modifyRecord(entry) : (item==='common.delete') ? deleteRecord(entry) : (item==='common.booking') ? bookingRecord(entry) : ((item === 'common.sendPdf') ? sendRecord(entry) : printRecord(entry))"
                            :title="(item === 'common.modify') ? $t('common.modify') : (item === 'common.delete') ? $t('common.delete') : (item === 'common.booking') ? $t('common.booking') : ((item === 'common.sendPdf') ?$t('common.sendPdf') : $t('common.print'))"
                          ></lte-button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </td>
              </tr>
            </ul>

            <ul
              v-if="tblBorder != undefined"
              style="display: contents;margin:0;padding: 0; border:1px solid red;"
            >
              <tr
                :style="tblBorder"
                v-for="entry in filteredData"
                :key="entry.id"
                :class="{active_line: (getStatusField == true) ? (status_field['apartment.apartment_status'] == entry['apartment.apartment_status']  ? true : false ) : false }"
              >
                <!-- <td v-for="key in columns" :style="tblBorder" :key="key.id">{{entry[key]}}</td> -->
                <!-- {{entry['apartment_status']}} -->

                <!-- Add Column CheckBox -->
                <td v-if="useCheckBox" style="width:2%;">
                  <!-- <b-form-checkbox v-model="checkIdItems" :value="entry.id" id="entry.id" @change="checkItems(entry.id)"></b-form-checkbox> -->
                  <input
                    type="checkbox"
                    :value="isGetInformationInvoice != undefined && isGetInformationInvoice ? entry : entry.id"
                    id="entry.id"
                    v-model="selected"
                    @change="checkItems($event)"
                  />
                </td>
                <!-- Add Column CheckBox -->
                <td v-for="header_key in columns" :style="tableBorder" :key="header_key.id">
                  <span v-if="getCustomColumns">
                    <span
                      v-if="Object.keys(customColumns).includes(header_key) && entry[header_key] == $t('apartment.open')"
                      :class="[{'label': customColumns[`${header_key}`]['apartment.open']}, customColumns[`${header_key}`]['apartment.open']]"
                    >{{ entry[header_key]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes(header_key) && entry[header_key] == $t('apartment.issue')"
                      :class="[{'label': customColumns[`${header_key}`]['apartment.issue']}, customColumns[`${header_key}`]['apartment.issue']]"
                    >{{ entry[header_key]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes(header_key) && entry[header_key] == $t('apartment.paid')"
                      :class="[{'label': customColumns[`${header_key}`]['apartment.paid']}, customColumns[`${header_key}`]['apartment.paid']]"
                    >{{ entry[header_key]}}</span>
                    <span
                      v-else-if="Object.keys(customColumns).includes(header_key)"
                      :class="[{'label': customColumns[`${header_key}`]}, customColumns[`${header_key}`]]"
                    >{{ entry[header_key]}}</span>
                    <span v-else>{{ entry[header_key]}}</span>
                  </span>
                  <span v-else>{{entry[header_key]}}</span>
                </td>
                <!-- Add Views -->
                <td v-if="views !=undefined">
                  <lte-hyperlink v-for="item in views" :key="item" left_icon="fa fa-eye">{{item}}</lte-hyperlink>
                </td>
                <!-- Add Actions Edit/Delete -->
                <td v-if="actions !=undefined">
                  <!-- <lte-button
                  v-for="item in actions"
                  :key="item"
                  :type="(item === 'common.modify') ? 'btn btn-primary' : ((item === 'common.delete') ? 'btn btn-danger' : 'btn info')"
                  :right_icon="(item ==='common.modify') ? 'glyphicon glyphicon-edit' : ((item ==='common.delete') ? 'glyphicon glyphicon-trash' : 'fa fa-print')"
                  style="margin-left:6px;"
                  :target="(item ==='common.modify') ? '' : ((item ==='common.delete') ? '' : '_blank')"
                  @click="(item==='common.modify') ? modifyRecord(entry) : (item==='common.delete') ? deleteRecord(entry) : printRecord(entry)"
                  >-->
                  <!-- {{item === 'common.modify' ? $t('common.modify') : $t('common.delete') }}             -->
                  <!-- </lte-button> -->
                  <div class="btn-group">
                    <button
                      id="more-btn"
                      type="button"
                      class="btn more-btn dropdown-toggle"
                      :class="colorAction !==undefined ? colorAction : 'btn-danger'"
                      data-toggle="dropdown"
                    >
                      <span class="more-dot"></span>
                      <span class="more-dot"></span>
                      <span class="more-dot"></span>
                    </button>
                    <ul
                      class="dropdown-menu"
                      role="menu"
                      style="min-width:90px;margin-top:0px;text-align:center;"
                    >
                      <li v-for="item in actions" :key="item">
                        <lte-button
                          :key="item"
                          :type="
                          (item === 'common.modify') ? 'btn btn-primary' : ((item === 'common.delete') ? 'btn btn-danger' : ((item == 'common.sendPdf') ? 'btn btn-warning' : 'btn info'))"
                          :right_icon="(item ==='common.modify') ? 'glyphicon glyphicon-edit' : ((item ==='common.delete') ? 'glyphicon glyphicon-trash' : ((item == 'common.sendPdf') ? 'fa fa-file-pdf-o' : 'fa fa-print'))"
                          :target="(item ==='common.modify') ? '' : ((item ==='common.delete') ? '' : ((item == 'common.sendPdf') ? '' : '_blank'))"
                          style="margin-left:6px;"
                          @click="(item==='common.modify') ? modifyRecord(entry) : (item==='common.delete') ? deleteRecord(entry) : (item==='common.sendPdf' ? sendRecord(entry) : printRecord(entry))"
                        ></lte-button>
                      </li>
                    </ul>
                  </div>
                </td>
              </tr>
            </ul>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Pagination -->
  </div>
</template>

<script>
import LTEButton from "./LTEButton.vue";
import Multiselect from "vue-multiselect";
import { LTEActionTypeEnum } from '@/components/LTEEnum'
import LTEHyperlink from "@/components/LTEHyperlink.vue";
import utils from '@/lib/utils'

export default {
  name: "lte-table",
  props: [
    "data",
    "columns",
    "actions",
    "views",
    "search_filter",
    "hdBackground",
    "tblBorder",
    "isVisibility",
    "useFilter",
    "useFilterSelect",
    "useCheckBox",
    "customColumns",
    "arrow",
    "status_field",
    "row_mouse_pointer",
    "colorAction",
    "boxStyle",
    "paymentStatusOptions",
    "isGetInformationInvoice",
    "containLink"
  ],
  data() {
    return {
      searchQuery: "",
      sortKey: "",
      sortOrders: {},
      recordData: {},
      actionsType: LTEActionTypeEnum.DEFAULT,
      tblDefaultBorder: "border: 1px solid #f4f4f4",
      hdDefaultBackground: "background-color: #008f68",
      isModalVisible: false,
      emitfilteredData: [],
      keepCheckItems: [],
      selected: [],
      paymentStatusSelected: [],
      selectAll: false,
      hdBackground1:
        "background-color: #4b646f;color:white;border:1px solid white;"
    };
  },
  watch: {
    customColumns: function() {},
    columns: function() {
      // console.log(this.columns);
    }
  },
  computed: {
    getCustomColumns: function() {
      let isCheck = true;
      if (this.customColumns == undefined) {
        isCheck = false;
      }
      return isCheck;
    },
    getStatusField: function() {
      let isCheckStatus = true;
      if (this.status_field == undefined) {
        isCheckStatus = false;
      }
      return isCheckStatus;
    },
    filteredData: function() {
      //does not this feature
      // if (!this.useFilter) {
      //   return this.data;
      // }
      let sortKey = this.sortKey;
      let filterKey = "";
      if (this.useFilter) {
        filterKey = this.searchQuery && this.searchQuery.toLowerCase().trim();
      } else if (this.useFilterSelect) {
        filterKey = this.paymentStatusSelected;
      }
      let order = this.sortOrders[sortKey] || 1;
      let data = this.data;
      if (this.useFilterSelect && filterKey.length > 0) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            for (let i = 0, size = filterKey.length; i < size; i++) {
              if (
                String(row[key])
                  .toLowerCase()
                  .startsWith(filterKey[i].text.toLowerCase())
              ) {
                return true;
              }
            }
          });
        });
      } else if (this.useFilter && filterKey) {
        data = data.filter(function(row) {
          return Object.keys(row).some(function(key) {
            /*return (
              String(row[key])
                .toLowerCase()
                .indexOf(filterKey) > -1
            );*/
            return String(row[key])
              .toLowerCase()
              .startsWith(filterKey);
          });
        });
      }
      if (sortKey) {
        data = data.slice().sort(function(a, b) {
          a = a[sortKey];
          b = b[sortKey];
          return (a === b ? 0 : a > b ? 1 : -1) * order;
        });
      }

      this.$emit("filters", data);
      this.$emit("searchQuery", this.searchQuery);
      return data;
    },
    tableBorder: function() {
      return this.tblDefaultBorder;
    },
    headerDefaultBackground: function() {
      return this.hdDefaultBackground;
    }
  },
  filters: {
    capitalize: function(str) {
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
  methods: {
    sortBy: function(key) {
      this.sortKey = key;
      this.sortOrders[key] = this.sortOrders[key] * -1;
    },
    verifyColumn: function(status) {
      let _status = "";
      if (status == 1) {
        _status = this.$t("apartment.open");
      } else if (status == 2) {
        _status = this.$t("apartment.issue");
      } else if (status == 3) {
        _status = this.$t("apartment.paid");
      } else if (status == 4) {
        _status = this.$t("report.cancelled");
      } else {
        _status = "Partial paid";
      }
      return _status;
    },
    modifyRecord: function(data) {
      var self = this;
      self.actionsType = LTEActionTypeEnum.MODIFY;
      self.recordData = data;
      self.isModalVisible = false;
      self.$emit(
        "actions",
        self.recordData,
        self.actionsType,
        self.isModalVisible
      );
    },
    deleteRecord: function(data) {
      var self = this;
      self.actionsType = LTEActionTypeEnum.DELETED;
      self.recordData = data;
      self.isModalVisible = true;
      self.$emit(
        "actions",
        self.recordData,
        self.actionsType,
        self.isModalVisible
      );
    },
    printRecord: function(data) {
      var self = this;
      self.actionsType = LTEActionTypeEnum.PRINT;
      self.recordData = data;
      self.isModalVisible = true;
      self.$emit(
        "actions",
        self.recordData,
        self.actionsType,
        self.isModalVisible
      );
    },
    bookingRecord: function(data) {
      var self = this;
      self.actionsType = LTEActionTypeEnum.BOOKING;
      self.recordData = data;
      self.isModalVisible = false;
      self.$emit(
        "actions",
        self.recordData,
        self.actionsType,
        self.isModalVisible
      );
    },
    sendRecord: function(data) {
      var self = this;
      self.actionsType = LTEActionTypeEnum.SEND_PDF;
      self.recordData = data;
      self.isModalVisible = false;
      self.$emit(
        "actions",
        self.recordData,
        self.actionsType,
        self.isModalVisible
      );
    },
    filterDataOnTable: function() {
      var self = this;
      self.emitfilteredData = this.filteredData;
      self.$emit("filters", self.emitfilteredData);
      self.$emit("searchQuery", this.searchQuery);
    },
    onClickItemRow: function(entryId) {
      this.$emit("onClickItemRow", entryId);
    },
    stop: function(e) {
      e.stopPropagation();
    },
    checkItems: function(data) {
      this.$emit("selectedItems", this.selected, this.selectAll);
    },
    select: function() {
      this.selected = [];
      let data = [];
      data = this.filteredData;
      if (this.selectAll) {
        for (let i in data) {
          if (!utils.isNull(this.isGetInformationInvoice) && this.isGetInformationInvoice) {
            this.selected.push(data[i]);
          } else {
            if(Object.keys(data[i]).includes('apartment.status')  ) {
                this.selected.push(data[i]["id"]);
            } 
          }
        }
      }
      this.$emit("selectedItems", this.selected, this.selectAll);
    },
    checkIsMonthCurrent: function(date) {
      var now = new Date();
      var check = new Date(date);
      if (check.getMonth() == now.getMonth()) return true;
      return false;
    },
    isInteger: function(str) {
      return typeof str === "number" && Math.round(str) == str;
    },
    isFloat: function(str) {
      return typeof str === "number" && !isInteger(str);
    },
    isDateString: function(str) {
      var regexDate = RegExp(
        "^[0-9]{2}[/][0-9]{2}[/][0-9]{4}.[0-9]{2}.+[0-9]+$"
      ); //  ^[0-9]+/[0-9]+/[0-9]+$
      return regexDate.test(str);
    },
    isNumber: function(str) {
      var regexDate = RegExp("^[0-9\\.,]+$");
      return regexDate.test(str);
    }
  },
  components: {
    "lte-button": LTEButton,
    "lte-hyperlink": LTEHyperlink,
    Multiselect
  },
  created() {
    let sortOrders = {};
    if (this.columns[0]["text"]) {
      this.columns.forEach(function(key) {
        sortOrders[key.text] = 1;
      });
    } else {
      this.columns.forEach(function(key) {
        sortOrders[key] = 1;
      });
    }

    this.sortOrders = sortOrders;
    this.$emit("searchQuery", this.searchQuery);
  }
};
</script>

<style lang="scss" scoped>
.row_mouse_pointer {
  cursor: pointer;
}

.isVisibility {
  display: none;
}
table > th {
  cursor: pointer;
}
div .right-search {
  width: 300px;
  margin-bottom: 5px;
  float: right;
}

div .left-search {
  width: 300px;
  margin-bottom: 5px;
  float: left;
}

th,
td {
  min-width: 50px;
  padding: 5px 7px;
  // padding: 10px 20px;
}

th.active {
  color: aquamarine;
}

th.active .arrow {
  opacity: 1;
}

.arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid #fae042;
}

.arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid #fae042;
}

th.active .other_color_arrow {
  opacity: 1;
}

.other_color_arrow {
  display: inline-block;
  vertical-align: middle;
  width: 0;
  height: 0;
  margin-left: 5px;
  opacity: 0.66;
}

.other_color_arrow.asc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-bottom: 4px solid black;
}

.other_color_arrow.dsc {
  border-left: 4px solid transparent;
  border-right: 4px solid transparent;
  border-top: 4px solid black;
}

#grid-template {
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  -webkit-flex-direction: column;
  width: 600px;
}
.custom-box {
  border-radius: 3px;
  background: #ffffff;
  border: 1px solid #e6e9ed;
  border-bottom: 0px;
  margin-bottom: 2px;
  width: 100%;
  -webkit-box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
  box-shadow: 0 1px 0px rgba(0, 0, 0, 0.1);
}
.active_line {
  // wheat
  background-color: lightblue;
}
.more-btn,
.more-menu-btn {
  border-radius: 5px;
  background-color: #c9302c;
  border: 0 none;
  // border-color: #ac2925;
  line-height: normal;
  overflow: visible;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  width: 100%;
  text-align: left;
  margin-bottom: 0px;
  outline: none;
  cursor: pointer;
}

.more-dot {
  background-color: white;
  margin: 0 auto;
  display: inline-block;
  width: 5px;
  height: 5px;
  margin-right: 1px;
  margin-bottom: 2px;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.label-darkcyan {
  background-color: darkcyan !important;
}
.label-crimson {
  background-color: crimson !important;
}
.label-darkblue {
  background-color: darkblue !important;
}
</style>



// WEBPACK FOOTER //
// src/components/LTETableInvoiceGeneralInvoice.vue